<script>
  import Link from '/Atoms/Markdown/Link'
  import MarkdownBlock from '/Atoms/MarkdownBlock'

  export let footnotes = []
  export let almanac = false
</script>

<dl class="footnotes" class:almanac>
  {#each footnotes as fn}
    <dt>
      <Link name={fn.anchor} href={fn.link} text={fn.number} />
    </dt>
    <dd>
      <MarkdownBlock source={fn.textMd} {almanac} article footnotes />
    </dd>
  {/each}
</dl>

<style lang="scss">
  .footnotes.almanac, :global(.footnotes.almanac a) {
    @include typo-serif-caption-18;
  }
  .footnotes {
    text-align: left;
  }
  dt {
    float: left;
    width: 2em;
  }
  dd {
    padding-left: 2em;
  }
</style>